export const DELIVERED = "DELIVERED";
export const OUT_FOR_DELIVERY = "OUT_FOR_DELIVERY";
export const ORDERED = "ORDERED";
export const IN_TRANSIT = "IN_TRANSIT";
export const UNDISPLAYED = "UNDISPLAYED";
export const GET_TRACKING_DETAILS_QUERY_KEY = "shipment-details";
export const RECEIVED_AT_ORIGIN = "RECEIVED_AT_ORIGIN";
export const CONTAINERIZED = "CONTAINERIZED";
export const LOADED = "LOADED";
export const DEPARTED = "DEPARTED";
export const ARRIVED = "ARRIVED";
export const UNLOADED = "UNLOADED";
export const MIDDLE_MILE_AIR = "MIDDLE_MILE_AIR";
export const PACKAGE_DELIVERY = "PACKAGE_DELIVERY";
export const SPD = "SPD";
export const LTL = "LTL";
export const BOOKING_CONFIRMED = "BOOKING_CONFIRMED";
export const SHIPPED = "SHIPPED";
export const IN_TRANSIT_TO_PICKUP = "IN_TRANSIT_TO_PICKUP";
export const CARRIER_RECEIVED_SHIPMENT = "CARRIER_RECEIVED_SHIPMENT";
export const DEPARTED_TERMINAL = "DEPARTED_TERMINAL";
export const PICKUP_FAILED = "PICKUP_FAILED";
export const SUPPLY_CHAIN_TRACKING_EVENTS_INPUT = "supplyChainTrackingEvents";